var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValuesIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 145,
    viewBox: "32 8 97 145",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.376 32.7353C104.376 19.5454 93.6873 8.85297 80.4993 8.85297C67.3114 8.85297 56.623 19.5454 56.623 32.7353C56.623 45.9252 67.3135 56.6176 80.4993 56.6176C93.6852 56.6176 104.376 45.9252 104.376 32.7353Z",
    fill: "#EAB1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.261 152.139C128.261 125.761 106.879 104.378 80.5028 104.378C54.127 104.378 32.7441 125.761 32.7441 152.139H128.261Z",
    fill: "#FABBAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5008 104.378H80.5028C106.879 104.378 128.259 82.9935 128.259 56.6177H80.5008C54.125 56.6177 32.7422 78.0005 32.7422 104.378H80.5008Z",
    fill: "#FF794E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesIcon4);
export default __webpack_public_path__ + "static/media/values_icon4.535d1be151a584ad5b998954f1212b83.svg";
export { ForwardRef as ReactComponent };